var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1920 1920",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M696.208 156.026c206.72 0 374.882 168.161 374.882 374.881v107.11c0 113.428-51.734 214.003-131.637 282.874 58.053 6.962 115.892 15.745 173.195 27.741 162.056 34.168 279.768 188.726 279.768 367.598v205.757l-21.85 16.066c-117.391 86.223-356.78 225.786-675.108 225.786-16.923 0-33.953-.429-51.198-1.179-280.518-13.174-493.343-129.387-622.517-224.714L0 1521.879v-205.756c0-178.872 117.82-333.43 279.983-367.598 56.982-11.889 114.606-21.1 172.445-28.17-79.689-68.763-131.101-169.124-131.101-282.339V530.907c0-206.72 168.16-374.88 374.881-374.88Zm-88.9 321.327c-94.899 0-113.536 69.942-178.872 96.398v64.265c0 147.596 120.176 267.773 267.772 267.773s267.773-120.177 267.773-267.773V530.907c0-2.463-.643-4.82-.75-7.39-.636.578-1.271 1.158-1.905 1.738l-1.9 1.745-.948.874-1.895 1.75-1.893 1.751-1.894 1.751-.948.875-1.898 1.748c-27.24 25.027-56.053 48.713-110.216 48.713-116.749 0-116.749-107.11-232.426-107.11ZM1839.915 156 1920 236.085l-200.269 200.269L1920 636.623l-80.085 80.085-200.269-200.27-200.156 200.27-80.198-80.085 200.27-200.269-200.27-200.269L1439.49 156l200.156 200.269L1839.915 156Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateIcon);
export default __webpack_public_path__ + "static/media/deactivate-icon.37553e1dbaf0ae38a2e40d3edfe0a78f.svg";
export { ForwardRef as ReactComponent };